import { render, staticRenderFns } from "./ContasPagarFiltro.vue?vue&type=template&id=5b6d93b4&scoped=true&"
import script from "./ContasPagarFiltro.vue?vue&type=script&setup=true&lang=js&"
export * from "./ContasPagarFiltro.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d93b4",
  null
  
)

export default component.exports